export const langToLangApi: Record<string, string> = {
    en: "en-US",
    ch: "ch-CH",
    cn: "ch-CH",
    es: "es-ES",
    de: "de-de",
    ru: "ru-RU",
};

export const LANGUAGES: Record<string, { label: string; flag: string }> = {
    ru: { label: "Русский", flag: "🇷🇺" },
    en: { label: "English", flag: "🇬🇧" },
    de: { label: "Deutsch", flag: "🇩🇪" },
    es: { label: "Español", flag: "🇪🇸" },
    cn: { label: "中文", flag: "🇨🇳" },
};
